import React from 'react';
import { graphql, HeadProps, PageProps } from 'gatsby';
import { CareersNewsListingPageQueryQuery, Kfh_ContentCareersNewsListingType } from '../../types/graphqlTypes';
import { ArticleListing } from '../../components/ArticleListing';
import { SEO } from '../../components/Seo';

interface PageContext {
  ids: number[];
  pageNumber: number;
  totalPages: number;
  pathName: string;
  totalCount: number;
}

const CareersNewsListingPage = ({
  data: { page },
  pageContext,
}: PageProps<CareersNewsListingPageQueryQuery, PageContext>) => {
  const { title, leadText } = page.layout as unknown as Kfh_ContentCareersNewsListingType;
  const { seoSettings } = page;

  return (
    <>
      <ArticleListing
        seoSettings={seoSettings}
        title={title}
        lead={leadText}
        listingPages={page?.listingPages}
        pageContext={pageContext}
        cardActionLabel="Read more"
      />
    </>
  );
};

export default CareersNewsListingPage;

export const Head = ({ data }: HeadProps<CareersNewsListingPageQueryQuery>) => {
  const { seoSettings, feed } = data.page;
  return (
    <SEO
      data={seoSettings}
      image={feed?.featuredImage?.localFile?.resize?.src ? feed.featuredImage.localFile.resize.src : undefined}
    />
  );
};

export const pageQuery = graphql`
  query CareersNewsListingPageQuery($ids: [String], $pageId: String) {
    page: kfhContentPageUmbracoType(id: { eq: $pageId }) {
      remoteTypeName
      remoteId
      pageName
      relativeUrl
      parentId
      id
      seoSettings {
        ...SEO
      }
      feed {
        featuredImage {
          ...PageSocialImage
        }
      }
      layout {
        ... on KFH_ContentCareersNewsListingType {
          title
          leadText
        }
      }
      classification {
        audiences
        services
      }
      listingPages(ids: $ids) {
        pageName
        id
        relativeUrl
        feed {
          featuredImage {
            localFile {
              gatsbyImage(
                width: 452
                height: 340
                layout: CONSTRAINED
                placeholder: NONE
                quality: 80
                backgroundColor: "#F5F5F5"
              )
            }
          }
        }
        publishDate
        layout {
          ... on KFH_ContentNewsArticleType {
            title
          }
        }
      }
    }
  }
`;
